<ng-template #beneficiaryOperationModal>
    <div class="page-modal-section">
      <div class="page-modal-heading-section">
        <span>{{ operation_type }} Beneficiary Details</span>
        <span
          class="page-modal-close-icon"
          (click)="closeBeneficiaryOperationModal()"
          >&times;</span
        >
      </div>
      <div class="page-modal-content-section">
        <div class="page-modal-input-section">
          <p class="page-modal-input-label">First Name *</p>
          <input
            type="text"
            class="page-modal-input"
            [(ngModel)]="beneficiary_data.first_name"
          />
          <p class="page-modal-input-error" *ngIf="beneficiary_data_errors.first_name">
            First Name is Required.
          </p>
        </div>
  
        <div class="page-modal-input-section">
          <p class="page-modal-input-label">Last Name *</p>
          <input
            type="text"
            class="page-modal-input"
            [(ngModel)]="beneficiary_data.last_name"
          />
          <p class="page-modal-input-error" *ngIf="beneficiary_data_errors.last_name">
            Last Name is Required.
          </p>
        </div>
  
        <div class="page-modal-input-section">
          <p class="page-modal-input-label">Is Primary</p>
          <mat-radio-group [(ngModel)]="beneficiary_data.is_primary">
            <mat-radio-button [value]="true">Yes</mat-radio-button>
            <mat-radio-button [value]="false">No</mat-radio-button>
          </mat-radio-group>
          <!-- <p class="page-modal-input-error" *ngIf="beneficiary_data_errors.is_primary">
            Primary Beneficiary is required
          </p> -->
        </div>
  
        <div class="page-modal-input-section">
          <p class="page-modal-input-label">Email</p>
          <input
            type="text"
            class="page-modal-input"
            [(ngModel)]="beneficiary_data.email"
          />
          <!-- <p class="page-modal-input-error" *ngIf="beneficiary_data_errors.email">
            Enter valid Email.
          </p> -->
        </div>
  
        <div class="page-modal-input-section">
          <p class="page-modal-input-label">Date of Birth</p>
          <input
            type="text"
            class="page-modal-input"
            bsDatepicker
            [maxDate]="current_date"
            [(ngModel)]="beneficiary_data.birth_date"
            [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            placement="left"
          />
          <!-- <p class="page-modal-input-error" *ngIf="beneficiary_data_errors.birth_date">
            Date of Birth is Required.
          </p> -->
        </div>
  
        <div class="page-modal-input-section">
          <p class="page-modal-input-label">Gender</p>
          <mat-select class="page-modal-input" [(ngModel)]="beneficiary_data.gender">
            <mat-option [value]="''">Select Gender</mat-option>
            <mat-option *ngFor="let gender of genders_list" [value]="gender.id" (click)="beneficiary_data.gender_name = gender.name">{{gender.name}}</mat-option>
          </mat-select>
          <!-- <p class="page-modal-input-error" *ngIf="beneficiary_data_errors.gender">
            Type is Required.
          </p> -->
        </div>
  
        <div class="page-modal-input-section">
          <p class="page-modal-input-label">Relationship</p>
          <mat-select class="page-modal-input" [(ngModel)]="beneficiary_data.relationship_type">
            <mat-option [value]="''">Select Relationship</mat-option>
            <mat-option *ngFor="let relationship of relationships_list" [value]="relationship.id" (click)="beneficiary_data.relationship_type_name = relationship.name">{{relationship.name}}</mat-option>
          </mat-select>
          <!-- <p class="page-modal-input-error" *ngIf="beneficiary_data_errors.relationship_type">
            Relationship is Required.
          </p> -->
        </div>
  
        <div class="page-modal-input-section">
          <p class="page-modal-input-label">Allocation(%) *</p>
          <input
            type="text"
            class="page-modal-input"
            [(ngModel)]="beneficiary_data.percentage_allocation"
            (keypress)="numberOnly($event)"
          />
          <p class="page-modal-input-error" *ngIf="beneficiary_data_errors.percentage_allocation">
            Allocations of all beneficiaries cannot exceed 100
          </p>
        </div>
  
      </div>
      <div class="page-modal-footer-section">
        <button class="page-modal-primary-button" (click)="saveBeneficiaryData()">
          Save
        </button>
        <button
          class="page-modal-secondary-button"
          (click)="closeBeneficiaryOperationModal()"
        >
          Cancel
        </button>
      </div>
    </div>
  </ng-template>
  
  <ng-template #beneficiaryDeleteModal>
      <div class="page-modal-section">
          <div class="page-modal-heading-section">
              <span>Delete Beneficiary Details</span>
              <span class="page-modal-close-icon" (click)="closeBeneficiaryDeleteModal()"
              >&times;</span
              >
          </div>
          <div class="page-modal-content-section">
              <p class="page-modal-delete-description">
                  Are you sure you want to delete?
              </p>
          </div>
          <div class="page-modal-footer-section">
              <button class="page-modal-primary-button" (click)="deleteBeneficiaryData()">
                  Yes
              </button>
              <button
              class="page-modal-secondary-button"
              (click)="closeBeneficiaryDeleteModal()"
              >
              No
          </button>
      </div>
  </div>
  </ng-template>